<template>
  <div class="terms-of-service max-w-4xl mx-auto">
    <div class="glass-card p-8">
      <!-- 헤더 -->
      <div class="text-center mb-8">
        <div class="text-4xl mb-3">📜</div>
        <h1 class="text-3xl font-bold text-gradient mb-2">이용약관</h1>
        <p class="text-gray-600">최종 수정일: 2025년 1월 29일</p>
      </div>

      <!-- 본문 -->
      <div class="space-y-8 text-gray-700">
        <!-- 제1조 목적 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제1조 (목적)</h2>
          <div class="bg-blue-50 p-4 rounded-lg">
            <p>
              본 약관은 Lotto Genius (이하 "서비스")가 제공하는 로또 번호 생성 및 통계 분석 서비스의 이용과 관련하여 
              서비스와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </div>
        </section>

        <!-- 제2조 용어의 정의 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제2조 (용어의 정의)</h2>
          <div class="bg-gray-50 p-4 rounded-lg space-y-2">
            <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            <ul class="list-disc list-inside space-y-2 ml-4">
              <li>
                <strong>"서비스"</strong>란 로또 지니어스(Lotto Genius)가 제공하는 웹사이트 및 관련 제반 서비스를 의미합니다.
              </li>
              <li>
                <strong>"이용자"</strong>란 본 약관에 따라 서비스를 이용하는 모든 사용자를 의미합니다.
              </li>
              <li>
                <strong>"콘텐츠"</strong>란 서비스 내에서 제공되는 로또 번호, 통계 데이터, 분석 결과 등 모든 정보를 의미합니다.
              </li>
              <li>
                <strong>"AI 번호 생성"</strong>이란 인공지능 알고리즘을 활용한 번호 조합 생성 기능을 의미하며, 
                이는 순전히 엔터테인먼트 목적입니다.
              </li>
            </ul>
          </div>
        </section>

        <!-- 제3조 약관의 효력 및 변경 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제3조 (약관의 효력 및 변경)</h2>
          <div class="bg-purple-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 효력:</strong> 본 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다.
            </p>
            <p>
              <strong>② 게시:</strong> 본 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력을 발생합니다.
            </p>
            <p>
              <strong>③ 변경:</strong> 서비스는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 
              약관이 변경되는 경우 변경사항을 시행일자 7일 전부터 공지합니다.
            </p>
            <p>
              <strong>④ 동의:</strong> 이용자가 변경된 약관에 동의하지 않을 경우, 서비스 이용을 중단할 수 있습니다.
            </p>
          </div>
        </section>

        <!-- 제4조 서비스의 제공 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제4조 (서비스의 제공)</h2>
          <div class="bg-green-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 서비스 내용:</strong> 서비스는 다음과 같은 기능을 제공합니다.
            </p>
            <ul class="list-disc list-inside space-y-1 ml-4">
              <li>AI 및 패턴 기반 로또 번호 생성 (엔터테인먼트 목적)</li>
              <li>과거 로또 당첨번호 통계 및 분석</li>
              <li>당첨번호 히스토리 조회</li>
              <li>확률 교육 콘텐츠 제공</li>
              <li>기타 부가 서비스</li>
            </ul>
            <p>
              <strong>② 서비스 시간:</strong> 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
            </p>
            <p>
              <strong>③ 서비스 중단:</strong> 다음 각 호의 경우 서비스 제공이 일시 중단될 수 있습니다.
            </p>
            <ul class="list-disc list-inside space-y-1 ml-4 text-sm">
              <li>시스템 정기점검, 보수, 교체</li>
              <li>통신두절, 서버 장애 등 불가항력적 사유</li>
              <li>기타 서비스 운영상 필요한 경우</li>
            </ul>
          </div>
        </section>

        <!-- 제5조 면책 조항 (중요!) -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-red-600">제5조 (면책 조항) ⚠️</h2>
          <div class="bg-red-50 p-4 rounded-lg border-2 border-red-300 space-y-3">
            <div class="bg-white p-4 rounded">
              <p class="font-bold text-red-700 mb-2">🚨 매우 중요한 고지사항</p>
              <p class="mb-3">
                본 서비스는 <strong class="text-red-600">순전히 엔터테인먼트 및 교육 목적</strong>으로 제공되며, 
                다음 사항에 대해 명확히 고지합니다:
              </p>
              <ul class="list-disc list-inside space-y-2 ml-4 text-sm">
                <li>
                  <strong>모든 로또 번호 조합의 당첨 확률은 정확히 1/8,145,060로 동일합니다.</strong>
                </li>
                <li>
                  AI, 통계 분석, 패턴 생성 등 어떠한 방법도 <strong>당첨 확률을 높일 수 없습니다.</strong>
                </li>
                <li>
                  본 서비스에서 생성된 번호가 당첨되더라도 이는 <strong>순전히 우연</strong>이며, 
                  서비스의 기능과는 <strong>무관</strong>합니다.
                </li>
                <li>
                  과거 당첨번호 분석은 <strong>미래 결과에 영향을 주지 않습니다.</strong>
                </li>
              </ul>
            </div>
            
            <p>
              <strong>① 서비스 이용 결과:</strong> 서비스는 이용자가 서비스를 통해 생성한 번호로 로또를 구매하여 
              발생한 결과(당첨 또는 낙첨)에 대해 어떠한 책임도 지지 않습니다.
            </p>
            <p>
              <strong>② 정보의 정확성:</strong> 서비스는 제공하는 통계 정보의 정확성을 위해 노력하나, 
              동행복권 공식 데이터와 차이가 있을 수 있으며 이에 대한 책임을 지지 않습니다.
            </p>
            <p>
              <strong>③ 투자 손실:</strong> 로또 구매로 인한 금전적 손실에 대해 서비스는 책임을 지지 않습니다.
            </p>
            <p>
              <strong>④ 제3자 서비스:</strong> 서비스 내에서 제공하는 제3자 링크나 광고로 인해 발생하는 
              손해에 대해 책임을 지지 않습니다.
            </p>
          </div>
        </section>

        <!-- 제6조 이용자의 의무 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제6조 (이용자의 의무)</h2>
          <div class="bg-yellow-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 책임있는 이용:</strong> 이용자는 다음 행위를 하여서는 안 됩니다.
            </p>
            <ul class="list-disc list-inside space-y-1 ml-4 text-sm">
              <li>서비스 운영을 고의로 방해하는 행위</li>
              <li>타인의 개인정보를 도용하는 행위</li>
              <li>서비스의 정보를 상업적 목적으로 무단 사용하는 행위</li>
              <li>저작권 등 지적재산권을 침해하는 행위</li>
              <li>서비스 또는 제3자에게 피해를 주는 행위</li>
              <li>불법적인 목적으로 서비스를 이용하는 행위</li>
            </ul>
            <p>
              <strong>② 과도한 로또 구매 금지:</strong> 이용자는 본 서비스를 이용하여 생성된 번호에 과도하게 의존하거나 
              무분별한 로또 구매를 해서는 안 됩니다.
            </p>
            <p>
              <strong>③ 책임있는 게임:</strong> 이용자는 로또가 사행성 게임임을 인지하고, 개인의 재정 상황을 고려하여 
              책임감 있게 참여해야 합니다.
            </p>
          </div>
        </section>

        <!-- 제7조 저작권 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제7조 (저작권)</h2>
          <div class="bg-indigo-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 서비스의 저작권:</strong> 서비스가 작성한 저작물에 대한 저작권 및 기타 지적재산권은 
              서비스에 귀속됩니다.
            </p>
            <p>
              <strong>② 이용 제한:</strong> 이용자는 서비스를 이용함으로써 얻은 정보를 서비스의 사전 승낙 없이 
              복제, 송신, 출판, 배포, 방송 기타 방법으로 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
            </p>
            <p>
              <strong>③ 로또 데이터:</strong> 동행복권에서 제공하는 공식 로또 데이터의 저작권은 동행복권에 있으며, 
              본 서비스는 이를 공정이용 원칙에 따라 활용하고 있습니다.
            </p>
          </div>
        </section>

        <!-- 제8조 개인정보보호 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제8조 (개인정보보호)</h2>
          <div class="bg-purple-50 p-4 rounded-lg">
            <p>
              서비스는 관련 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다. 
              개인정보의 보호 및 이용에 대해서는 관련 법령 및 서비스의 개인정보처리방침이 적용됩니다.
            </p>
          </div>
        </section>

        <!-- 제9조 광고 게재 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제9조 (광고 게재)</h2>
          <div class="bg-gray-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 광고 게재:</strong> 서비스는 서비스 운영을 위해 서비스 화면에 광고를 게재할 수 있습니다.
            </p>
            <p>
              <strong>② 제3자 광고:</strong> 게재된 광고는 제3자가 제공하는 것이며, 서비스는 광고 내용에 대한 
              책임을 지지 않습니다.
            </p>
            <p>
              <strong>③ 광고 클릭:</strong> 이용자가 광고를 클릭하여 발생하는 결과에 대해 서비스는 책임을 지지 않습니다.
            </p>
          </div>
        </section>

        <!-- 제10조 분쟁 해결 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제10조 (분쟁 해결)</h2>
          <div class="bg-orange-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 준거법:</strong> 서비스와 이용자 간 제기된 소송은 대한민국 법을 준거법으로 합니다.
            </p>
            <p>
              <strong>② 관할법원:</strong> 서비스와 이용자 간 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 
              제기합니다.
            </p>
          </div>
        </section>

        <!-- 제11조 기타 -->
        <section>
          <h2 class="text-2xl font-bold mb-4 text-blue-600">제11조 (기타)</h2>
          <div class="bg-blue-50 p-4 rounded-lg space-y-3">
            <p>
              <strong>① 본 약관에 명시되지 않은 사항:</strong> 본 약관에 명시되지 않은 사항은 관계 법령 및 
              상관례에 따릅니다.
            </p>
            <p>
              <strong>② 부분 무효:</strong> 본 약관의 일부 조항이 무효로 판단되더라도 나머지 조항의 효력에는 
              영향을 미치지 않습니다.
            </p>
          </div>
        </section>

        <!-- 부칙 -->
        <section class="mt-8 pt-6 border-t border-gray-300">
          <h2 class="text-2xl font-bold mb-4">부칙</h2>
          <div class="bg-gray-50 p-4 rounded-lg">
            <p>본 약관은 2025년 1월 29일부터 시행됩니다.</p>
          </div>
        </section>

        <!-- 최종 고지 -->
        <section class="mt-8">
          <div class="bg-red-50 p-6 rounded-lg border-l-4 border-red-500">
            <h3 class="font-bold text-xl mb-3 text-red-800 flex items-center">
              <span class="text-2xl mr-2">⚠️</span>
              최종 고지사항
            </h3>
            <div class="space-y-2 text-red-700">
              <p class="font-bold">
                로또 지니어스는 엔터테인먼트 플랫폼입니다. 당첨을 보장하거나 확률을 높이지 않습니다.
              </p>
              <p>
                본 서비스를 이용함으로써 귀하는 위 약관의 모든 내용에 동의한 것으로 간주됩니다. 
                약관에 동의하지 않으실 경우 서비스 이용을 중단해 주시기 바랍니다.
              </p>
              <p class="text-sm mt-4">
                문의사항이 있으시면 하단의 '문의하기' 페이지를 이용해 주세요.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
// 스크립트가 필요하면 추가
</script>

<style scoped>
.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.glass-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
}

section {
  scroll-margin-top: 100px;
}
</style>
